// SPDX-License-Identifier: MIT
// Types partagés du sous-système plan-usage. Aucune I/O ici.

export type PlanTier = 'pro' | 'max5' | 'max20' | 'unknown';

export type UsageEvent =
  // Autoritatif : émis par le stream Claude (rate_limit_event). resetsAt = epoch s.
  | { kind: 'rate_limit'; status: 'allowed' | 'throttled'; resetsAt: number;
      rateLimitType: string; overageRejected: boolean }
  // Consommation d'un message assistant (ligne `result` du stream OU lue du JSONL).
  | { kind: 'usage'; timestampMs: number; inputTokens: number; cacheCreationTokens: number;
      cacheReadTokens: number; outputTokens: number; model: string }
  // Web : signal pauvre depuis les en-têtes de la réponse provider.
  | { kind: 'web_headers'; status: 'allowed' | 'throttled'; resetsAt: number | null };

export type UsageStatus = 'ok' | 'approaching' | 'throttled';
export type Confidence = 'authoritative' | 'estimated';
export type UsageSource = 'stream' | 'jsonl' | 'web-headers' | 'usage-command';

export interface WindowState {
  planTier: PlanTier;
  status: UsageStatus;
  resetsAt: number | null;        // epoch s ; fin de la fenêtre 5 h glissante
  fillPct: number | null;         // null si pas de plafond fiable
  burnRatePerMin: number | null;  // tokens/min sur la fenêtre active
  projectionMins: number | null;  // min avant limite au rythme courant
  confidence: Confidence;  // 'authoritative' = resetsAt came from a rate_limit_event;
                           // windowTokens may still be estimated from JSONL reconstruction
  source: UsageSource;
  windowTokens: number;           // total tokens facturables comptés dans la fenêtre
  planLabel?: string | null;      // type de forfait affichable ("Max", "Pro") — de `claude auth status` subscriptionType
}

// §3.1 spec — défauts V1 (constantes nommées, ajustables).
export const APPROACHING_MINS = 15;
export const APPROACHING_PCT = 85;
export const CHECKPOINT_MINS = 5;
export const REPEAT_THROTTLES = 2;
export const REPEAT_WINDOW_DAYS = 7;
export const MIN_HISTORY_RUNS = 3;
export const WINDOW_DURATION_MS = 5 * 60 * 60 * 1000; // fenêtre 5 h

// Le "coût" d'un message pour la fenêtre = input + cache_creation + output.
// (cache_read est quasi-gratuit et ne compte pas contre la limite de génération.)
export function billableTokens(e: Extract<UsageEvent, { kind: 'usage' }>): number {
  return e.inputTokens + e.cacheCreationTokens + e.outputTokens;
}
